import React, { Fragment, useEffect } from 'react';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import styled from 'styled-components';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Container from '../../components/Container';
import photosData from './photosData';

const GridListWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin: 8px 0px;
`;

const PhotoList = styled(GridList)`
`;

const Gallery = (props) => {

    useEffect(() => window.scrollTo(0,0));
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

    return (
        <Fragment>
            <Header />
                <Container>
                    <Typography variant="h6">小麦屋のギャラリー</Typography>
                    <Link target="_blank" href="https://www.instagram.com/komugiya_yaizu/">
                        <Typography align="center">インスタグラムでもっと見る</Typography>
                    </Link>
                    <GridListWrapper>
                        <PhotoList cols={isSmallScreen ? 2 : 5}>
                            {photosData.map((photo) => (
                                <GridListTile key={photo.img} cols={photo.cols || 1}>
                                    <img src={photo.img} alt={photo.title} />
                                </GridListTile>
                            ))}
                        </PhotoList>
                    </GridListWrapper>
                    <Link target="_blank" href="https://www.instagram.com/komugiya_yaizu/">
                        <Typography align="center">インスタグラムでもっと見る</Typography>
                    </Link>
                </Container>
            <Footer />
        </Fragment>
    )
}

export default Gallery;